import { z } from "zod";
import { eventCategoryIdSchema } from "./eventCategory.schemas";
import { eventOccasionIdSchema } from "./eventOccasion.schemas";

export const eventCancellationPolicyIdSchema = z.coerce
	.number()
	.int()
	.positive();

export const eventCancellationPolicySchema = z
	.object({
		eventCancellationPolicyId: eventCancellationPolicyIdSchema.optional(),
		tenantId: z.coerce.number().int().positive(),
		eventCategoryId: eventCategoryIdSchema.nullable(),
		eventOccasionId: eventOccasionIdSchema.nullable(),
		name: z.string().min(1).max(200),
		description: z.string().max(2000).nullable(),
		deadlineDays: z.coerce.number().int().min(0).max(365),
		deadlineHours: z.coerce.number().int().min(0).max(23),
		refundPercentage: z.coerce.number().int().min(0).max(100),
		sortOrder: z.coerce.number().int().min(0).default(0),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
		deletedAt: z.coerce.date().nullable().optional(),
	})
	.strict();

export const createEventCancellationPolicySchema = eventCancellationPolicySchema
	.omit({
		eventCancellationPolicyId: true,
		createdAt: true,
		updatedAt: true,
		deletedAt: true,
	})
	.extend({
		tenantId: z.coerce.number().int().positive().optional(),
	});

export const updateEventCancellationPolicySchema =
	createEventCancellationPolicySchema.partial({
		name: true,
		description: true,
		deadlineDays: true,
		deadlineHours: true,
		refundPercentage: true,
		sortOrder: true,
		eventCategoryId: true,
		eventOccasionId: true,
	});
